/**
 * 配置站点地图路由（新闻）
 * @priority 0.8
 * @changefreq daily
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    //* 新闻资讯
    {
        path: "/news/:type?",
        name: "News",
        meta: { type: "News", regular_type: "newstype", regular: "/:type?" },
        component: () => import("@/views/news/main/index.vue"),
    },
    {
        path: "/news/:type/:id",
        name: "NewsDetails",
        meta: { type: "News", regular_type: "news", regular: "news/:type/:id" },
        component: () => import("@/views/news/details/index.vue"),
    },
] as RouteRecordRaw[];
